import { USER_ROLE } from 'src/types';
import { analytics } from '../analytics';
import { CHAT_TRANSLATION_OPTION_UPDATED_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

export interface TrackMessagesTranslationProps {
  organisation_id?: number;
  user_id: string;
  user_role: USER_ROLE;
  case_id?: string;
  report_id?: string;
  translated: boolean;
  language?: string;
  source: string;
  reported_category?: string;
  determined_category?: string;
}

export const trackChatTranslationUpdatedEvent = (
  properties: TrackMessagesTranslationProps,
) => {
  return analytics.track(
    CHAT_TRANSLATION_OPTION_UPDATED_EVENT_IDS.CHAT_TRANSLATION_OPTION_UPDATED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export enum TRANSLATION_UPDATE_SOURCE {
  OPR = 'OPR',
  RESHUB = 'RESHUB',
}
